import React from 'react';
import { Accordion } from './Accordion';
export function Bonos() {
  const bonos = [{
    number: 'BONO 01',
    title: 'Plantilla de Presupuesto Mensual',
    icon: '📋',
    oldPrice: '$8.000',
    desc: 'Tu control financiero mensual completo, lista para usar.',
    paraQue: 'Para que controlar tus números no sea un dolor de cabeza. Completás tus datos en 20 minutos y tenés el control total de tu mes. Sin fórmulas, sin Excel complicado.'
  }, {
    number: 'BONO 02',
    title: 'Tracker de Ahorro Semanal Visual',
    icon: '📊',
    oldPrice: '$7.000',
    desc: '52 semanas de seguimiento visual de tu ahorro.',
    paraQue: 'Para que nunca dudes de que estás avanzando. Lo que se mide crece, lo que se ve no se abandona. Cada semana queda registrada y ves tu progreso real.'
  }, {
    number: 'BONO 03',
    title: 'Simulador de Interés Compuesto',
    icon: '🧮',
    oldPrice: '$8.000',
    desc: 'Calculá exactamente cuánto vas a tener en 1, 5, 10 y 20 años.',
    paraQue: 'Para que dejes de postergar. Con tus números reales ves el costo exacto de esperar y la proyección real de empezar hoy en 3 escenarios distintos.'
  }, {
    number: 'BONO 04',
    title: 'Checklist Mi Primera Inversión Real',
    icon: '✅',
    oldPrice: '$6.000',
    desc: 'El paso a paso exacto para ejecutar tu primera inversión sin errores.',
    paraQue: 'Para que el miedo no te frene. Seguís el checklist en orden y tu primera inversión se ejecuta sin posibilidad de bloquearte en el camino.'
  }, {
    number: 'BONO 05',
    title: 'Glosario Financiero — 30 Términos',
    icon: '📖',
    oldPrice: '$5.000',
    desc: 'Para que nadie te tome el pelo con palabras que no entendés.',
    paraQue: 'Para entender ETF, FCI, CEDEAR, UVA y dólar MEP sin necesitar ser economista. Cada término explicado en lenguaje humano con ejemplos en pesos reales.'
  }, {
    number: 'BONO 06',
    title: 'Guía de Inicio Rápido — 24 Horas',
    icon: '⚡',
    oldPrice: '$6.000',
    desc: 'El resumen ejecutivo para tener tu sistema funcionando mañana.',
    paraQue: 'Para los que quieren resultados ya. Las acciones exactas para arrancar tu sistema antes de que termine el día sin tener que leer todo de entrada.'
  }];
  return <section className="bg-gold text-navy py-16 px-4" data-id="element-31">
      <div className="max-w-[720px] mx-auto" data-id="element-32">
        <div className="text-center mb-10" data-id="element-33">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-3 leading-tight" data-id="element-34">
            6 bonos incluidos. Gratis. Siempre.
          </h2>
          <p className="text-[16px] font-bold text-navy/80" data-id="element-35">
            Valor total: $40.000 ARS → $0 con tu sistema.
          </p>
        </div>

        <div className="flex flex-col gap-3" data-id="element-36">
          {bonos.map((bono, index) => <Accordion key={index} className="!bg-white/20 !border-navy/10" headerClassName="hover:!bg-white/30" number={bono.number} title={<span className="font-bold text-[15px]" data-id="element-38">{bono.title}</span>} icon={<span data-id="element-39">{bono.icon}</span>} badge={<div className="flex items-center gap-2 mt-1" data-id="element-40">
                  <span className="line-through text-navy/50 text-xs" data-id="element-41">
                    {bono.oldPrice}
                  </span>
                  <span className="bg-navy text-white text-[10px] font-bold px-2 py-0.5 rounded uppercase" data-id="element-42">
                    GRATIS
                  </span>
                </div>} data-id="element-37">
              <div className="text-[14px] text-navy/90 space-y-3" data-id="element-43">
                <p className="font-medium" data-id="element-44">{bono.desc}</p>
                <div data-id="element-45">
                  <span className="font-bold block mb-1" data-id="element-46">Para qué sirve:</span>
                  <p className="leading-[1.5]" data-id="element-47">{bono.paraQue}</p>
                </div>
              </div>
            </Accordion>)}
        </div>
      </div>
    </section>;
}